<template>
<v-container>
  <v-row>
    <v-col>
      <!-- header -->
      <div>
        <p class="display-1 font-weight-light primary--text">
          We value your feedback
        </p>
      </div>

      <!-- section intro -->

      <div v-if="surveyType == 'manager'">
        <p v-if="isSelfSurvey">
          You have been asked to
          provide feedback about yourself
          in the following areas:
        </p>
        <p v-else>
          You have been asked to provide
          feedback about {{ params.EvaluateeFullName }}
          in the following areas:
        </p>
        <ul>
          <li style="margin-bottom: 16px">
            <span class="font-weight-black">
              Client & Business Development
            </span>
          </li>
          <li style="margin-bottom: 16px">
            <span class="font-weight-black">
              Leadership & People
            </span>
          </li>
          <li style="margin-bottom: 32px">
            <span class="font-weight-black">
              Ideas & Innovation
            </span>
          </li>
        </ul>
      </div>

      <div v-if="surveyType == 'principal'">
        <p v-if="isSelfSurvey" class="font-weight-light">
          You have been asked to
          provide feedback about yourself
          in the following areas:
        </p>
        <p v-else class="font-weight-light">
          You have been asked to provide
          feedback about {{ params.EvaluateeFullName }}
          in the following areas:
        </p>
        <ul>
          <li style="margin-bottom: 16px">
            <span class="font-weight-black">
              Leadership of the Firm
            </span>
          </li>
          <li style="margin-bottom: 16px">
            <span class="font-weight-black">
              Leadership of our People
            </span>
          </li>
          <li style="margin-bottom: 32px">
            <span class="font-weight-black">
              Client Portfolio,
              Innovation and Relationship Development
            </span>
          </li>
        </ul>
      </div>
      <!-- section outro -->
      <div class="mt-10">
        <p v-if="isSelfSurvey">
          Once you've completed your
          self-assessment you will
          have an opportunity to
          review your responses
          before proceeding to
          nominate feedback providers.
        </p>
        <p v-else>
          You will have an opportunity to review your responses before submitting.
        </p>
        <p>
          The process should take
          approximately 20 minutes.
          Please click start when
          you are ready to begin.
        </p>
        <p>
          (Please do not use the back
          button on your browser as you progress
          through the pages).
        </p>
      </div>
    </v-col>
  </v-row>

  <v-row class="mb-12 mt-12">
    <v-col>
      <div>
        <v-btn large
                class="font-weight-black submit"
                color="#7823dc"
                @click="nextButton()">
          Start Survey
        </v-btn>
      </div>
    </v-col>
  </v-row>

</v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Intro',

  data() {
    return {
      interactionYear: 2019,
    };
  },
  computed: {
    ...mapGetters([
      'currentStep',
      'surveyFlow',
      'isSelfSurvey',
      'surveyType',
    ]),
    params() {
      return this.$store.state.params;
    },
  },

  methods: {
    nextButton() {
      this.$store.commit('incrementCurrentStep');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      const isCompleted = (this.$store.state.currentStep === this.surveyFlow.length);
      this.$store.commit('storeResponse', {
        k: 'IsCompleted',
        v: isCompleted,
      });
      // Completed
      if (isCompleted) {
        this.$store.commit('storeResponse', {
          k: 'DateCompleted',
          v: new Date(),
        });
      }
      this.$store.dispatch('storeResponse');
    },
  },
};
</script>

<style scoped>

* {
  font-family: Arial, sans-serif !important;
}

.submit {
  margin-bottom: 5px;
  border-color: #7823dc;
  color: white !important;
}
</style>
